// Index file for the directory. Don't add anything else here.
import CarouselYogatimeCreation from './CarouselYogatimeCreation';
export default CarouselYogatimeCreation;
